/**
 * The dashboard Renewals widget's DEFAULT upcoming window.
 *
 * B9 gave this module a `buildUpcomingRenewalsQuery` that always returned
 * `bucket: 'upcoming'`, because the widget was a single days-ahead Select with
 * no other bucket to offer. B-01/B-02 gave the widget real Upcoming/Lapsed
 * tabs, and it now translates its window through the Renewals list page's own
 * `windowToQueueParams` (`pages/renewals/renewalExpiryWindow.ts`) -- the same
 * vocabulary, so the dashboard and the list cannot disagree about what
 * "upcoming" means. The builder was deleted rather than left beside it as a
 * second, subtly different translation of the same thing.
 *
 * What survives is the default itself: the widget opens on "Next 30 days",
 * which is also `settings.RENEWAL_QUEUE_DEFAULT_DAYS` -- what the backend
 * applies when `days` is omitted (`apps/renewals/queue.py::parse_window`), so
 * the widget's opening view matches an unfiltered request rather than
 * quietly narrowing or widening it.
 */
export const DEFAULT_UPCOMING_RENEWALS_DAYS = 30;
